import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchPatientOrderDetailApi, fetchPatientOrdersApi } from '../../api/patient-orders-api';

const initialState = {
  activeColumns: [],
  orders: [],
  orderDetail: {},
  statuses: [],
  products: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchPatientOrdersListing = createAsyncThunk(
  'patient/orders/listing',
  async (updatedParamsObject = {}) => {
    try {
      const paramsObj = {
        per_page: 10,
        'q[s]': 'order_date desc',
        ...updatedParamsObject,
      };
      const res = await fetchPatientOrdersApi(paramsObj);
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

export const loadMorePatientOrders = createAsyncThunk('patient/orders/loadmore', async (paramsObj = {}) => {
  try {
    const updatedParamsObject = {
      per_page: 10,
      ...paramsObj,
    };
    const res = await fetchPatientOrdersApi(updatedParamsObject);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const fetchPatientOrderDetail = createAsyncThunk('patient/order/detail', async (id) => {
  try {
    const res = await fetchPatientOrderDetailApi(id);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const PatientOrdersSlice = createSlice({
  name: 'patientorders',
  initialState,
  reducers: {
    setOrdersLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setOrdersActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPatientOrdersListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchPatientOrdersListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.orders = action?.payload?.data || [];
        state.statuses = action?.payload?.order_statuses || [];
        state.products = action?.payload?.products || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(loadMorePatientOrders.fulfilled, (state, action) => {
        state.orders = [...(state.orders || []), ...(action?.payload?.data || [])] || [];
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchPatientOrdersListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      })
      .addCase(fetchPatientOrderDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPatientOrderDetail.fulfilled, (state, action) => {
        state.orderDetail = action?.payload?.data || {};
        state.loading = false;
      })
      .addCase(fetchPatientOrderDetail.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setOrdersLoading, setOrdersActiveColumn } = PatientOrdersSlice.actions;
export default PatientOrdersSlice.reducer;
